import { COMMON_COLORS } from '@neteera/neteera-web-nextgen';
import { styled } from 'styled-components';

export const TitleWrapper = styled.div`
  grid-column: span 12;
`;

export const DashboardTabWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${COMMON_COLORS.teal100};

  padding: 0.5rem;
  height: 100%;
  overflow: hidden;
`;

export const DashboardLeftSide = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-between;
  width: calc(100% - 22.3rem - 19px);
  gap: 18px;
`;

export const DashboardRightSide = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-between;
  width: 22.3rem;
  gap: 3%;
`;
